import React from 'react';
import { motion } from 'framer-motion';
import { guidesData } from '../data/content';
import SafeIcon from '../common/SafeIcon';
import { FiArrowRight } from 'react-icons/fi';

const GuideCards = () => {
  return (
    <section id="guides" className="py-24 bg-aged-ivory scroll-mt-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-16 text-center">
          <h2 className="text-3xl md:text-4xl font-serif text-deep-charcoal mb-4">
            Explore the Padua Wedding Planning Guide
          </h2>
          <div className="w-16 h-px bg-estate-bronze mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {guidesData.map((guide, index) => (
            <motion.div
              key={guide.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              className="bg-vintage-white p-8 rounded-xl border border-warm-stone/30 shadow-editorial flex flex-col h-full group hover:border-estate-bronze/50 transition-colors duration-300"
            >
              <h3 className="text-xl font-serif text-deep-charcoal mb-4 group-hover:text-olive-grove transition-colors">
                {guide.title}
              </h3>
              <p className="text-deep-charcoal/70 font-light leading-relaxed mb-8 flex-grow">
                {guide.description}
              </p>
              <a 
                href={`#${guide.id}`}
                className="inline-flex items-center text-sm font-medium text-estate-bronze uppercase tracking-wider hover:text-olive-grove transition-colors mt-auto"
              >
                Read Guide
                <SafeIcon icon={FiArrowRight} className="ml-2 w-4 h-4" />
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GuideCards;